module.exports = __webpack_public_path__ + "static/media/favicon.e65a3c3f.ico";